@if (isSyncing) {
  <div class="loading-line"></div>
}
@if (isOffline) {
  <div class="offline-line"></div>
}